import React from 'react';
import {
    ACTION_DOWN, ACTION_DOWN_LEFT, ACTION_DOWN_RIGHT,
    ACTION_LEFT, ACTION_RELAX, ACTION_RIGHT,
    ACTION_UP, ACTION_UP_LEFT, ACTION_UP_RIGHT,
    ACTION_CENTER
} from "../../tools/EyeActions";
import { getAvatarState } from "./avatarUtils";

const pupilOffsets = {
    [ACTION_LEFT]:       { x: -8, y: 0 },
    [ACTION_RIGHT]:      { x: 8, y: 0 },
    [ACTION_UP]:         { x: 0, y: -8 },
    [ACTION_DOWN]:       { x: 0, y: 8 },
    [ACTION_UP_LEFT]:    { x: -6, y: -6 },
    [ACTION_UP_RIGHT]:   { x: 6, y: -6 },
    [ACTION_DOWN_LEFT]:  { x: -6, y: 6 },
    [ACTION_DOWN_RIGHT]: { x: 6, y: 6 },
    [ACTION_CENTER]:     { x: 0, y: 0 },
    [ACTION_RELAX]:      { x: 0, y: 0 },
};

class CatAvatar extends React.Component {
    render() {
        const { offset, isRelax, containerSize, isBlink, pulseClass } = getAvatarState(this.props, pupilOffsets);

        return (
            <div className="avatar-holder" style={{ width: containerSize, height: containerSize * 0.85 }}>
                <svg viewBox="0 0 200 180" className="avatar-svg">
                    {/* Pointed ears */}
                    <polygon points="42,68 22,8 72,48" fill="var(--avatar-primary)" stroke="var(--avatar-outline)" strokeWidth="2.5" strokeLinejoin="round" />
                    <polygon points="158,68 178,8 128,48" fill="var(--avatar-primary)" stroke="var(--avatar-outline)" strokeWidth="2.5" strokeLinejoin="round" />
                    <polygon points="44,62 30,20 66,50" fill="var(--avatar-inner)" />
                    <polygon points="156,62 170,20 134,50" fill="var(--avatar-inner)" />

                    {/* Head */}
                    <circle cx="100" cy="90" r="65" fill="var(--avatar-primary)" stroke="var(--avatar-outline)" strokeWidth="2.5" />
                    <circle cx="55" cy="102" r="12" fill="var(--avatar-secondary)" opacity="0.25" />
                    <circle cx="145" cy="102" r="12" fill="var(--avatar-secondary)" opacity="0.25" />

                    {/* Eyes */}
                    <g className={isBlink ? 'avatar-eye-blink' : ''} style={{ transformOrigin: '76px 82px' }}>
                        <ellipse cx="76" cy="82" rx="18" ry={isRelax ? 2 : 17} fill="var(--avatar-eye-white)" stroke="var(--avatar-outline)" strokeWidth="1.5" style={{ transition: 'ry 0.3s ease' }} />
                        {!isRelax && (<>
                            <circle className={pulseClass} cx={76 + offset.x} cy={82 + offset.y} r="8" fill="var(--avatar-pupil)" style={{ transition: 'cx 0.2s ease, cy 0.2s ease' }} />
                            <circle cx={76 + offset.x - 2.5} cy={82 + offset.y - 3} r="3" fill="var(--avatar-eye-shine)" style={{ transition: 'cx 0.2s ease, cy 0.2s ease' }} />
                        </>)}
                    </g>
                    <g className={isBlink ? 'avatar-eye-blink' : ''} style={{ transformOrigin: '124px 82px' }}>
                        <ellipse cx="124" cy="82" rx="18" ry={isRelax ? 2 : 17} fill="var(--avatar-eye-white)" stroke="var(--avatar-outline)" strokeWidth="1.5" style={{ transition: 'ry 0.3s ease' }} />
                        {!isRelax && (<>
                            <circle className={pulseClass} cx={124 + offset.x} cy={82 + offset.y} r="8" fill="var(--avatar-pupil)" style={{ transition: 'cx 0.2s ease, cy 0.2s ease' }} />
                            <circle cx={124 + offset.x - 2.5} cy={82 + offset.y - 3} r="3" fill="var(--avatar-eye-shine)" style={{ transition: 'cx 0.2s ease, cy 0.2s ease' }} />
                        </>)}
                    </g>

                    {/* Nose, mouth, whiskers */}
                    <polygon points="100,102 96,96 104,96" fill="var(--avatar-nose)" stroke="var(--avatar-outline)" strokeWidth="1" strokeLinejoin="round" />
                    <path d="M92 108 Q96 104 100 108 Q104 104 108 108" fill="none" stroke="var(--avatar-outline)" strokeWidth="1.5" strokeLinecap="round" />
                    <line x1="60" y1="96" x2="28" y2="90" stroke="var(--avatar-outline)" strokeWidth="1.2" strokeLinecap="round" />
                    <line x1="58" y1="102" x2="26" y2="102" stroke="var(--avatar-outline)" strokeWidth="1.2" strokeLinecap="round" />
                    <line x1="60" y1="108" x2="28" y2="114" stroke="var(--avatar-outline)" strokeWidth="1.2" strokeLinecap="round" />
                    <line x1="140" y1="96" x2="172" y2="90" stroke="var(--avatar-outline)" strokeWidth="1.2" strokeLinecap="round" />
                    <line x1="142" y1="102" x2="174" y2="102" stroke="var(--avatar-outline)" strokeWidth="1.2" strokeLinecap="round" />
                    <line x1="140" y1="108" x2="172" y2="114" stroke="var(--avatar-outline)" strokeWidth="1.2" strokeLinecap="round" />
                </svg>
            </div>
        );
    }
}

export default CatAvatar;
